export const REGEX = {
  asciiLettersOnly: /[^a-zA-Z]/g,
  email: /^\s*[^\s@]+@[^\s@]+\.[A-Za-z]{2,}\s*$/,
  policyNumber: /^\s*\d{4}([A-Za-z]{2}|[A-Za-z]\s)\d{6}\s*$/,
  submissionNumber: /^\s*\d{4,60}\s*$/,
} as const;
